import script from "./ReservationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReservationForm.vue?vue&type=script&setup=true&lang=ts"

import "./ReservationForm.vue?vue&type=style&index=0&id=4d22e550&lang=scss"

const __exports__ = script;

export default __exports__